import { Component, OnInit, HostListener, ViewChild, PLATFORM_ID, Inject, ElementRef, OnDestroy, ViewChildren, QueryList, TemplateRef, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, AfterViewInit, NgZone, Renderer2 } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Experience } from 'src/app/services/experience.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { AddExperience } from 'src/app/services/AddExperience.service';
import { LocationService } from 'src/app/services/location.service';
import { CartService } from 'src/app/services/cart.service';
import { MainService } from '../../main.service';
import { MessageService } from '../../message.service';
import { ExperienceDetailsService } from 'src/app/services/experience-details.service';
import { TicketEvaluation } from 'src/app/services/TicketEvaluation.service';
import { FindCouple } from 'src/app/services/findcouple.service';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import * as globalConstant from '../../global_constant';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Location } from '@angular/common';
import { SharedModule } from '../../share/shared.module';
import { VisitorsService } from 'src/app/services/Visitors.service';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { FilterService } from 'primeng/api';
import { ToastrService } from 'src/app/services/toastr.service';
import { CanonicalService } from 'src/app/services/canonical.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DragScrollComponent, DragScrollItemDirective } from 'ngx-drag-scroll';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
	selector: 'app-location-region',
	standalone: true,
	imports: [
		SharedModule,
		DragScrollItemDirective,
		NgxSkeletonLoaderModule,
		DragScrollComponent
	],
	templateUrl: './location-region.component.html',
	styleUrls: ['./location-region.component.css'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class LocationRegionComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('videoElement', { static: false }) videoElement: ElementRef;
	@ViewChild('buymodal', { static: false }) public buymodal: ModalDirective;
	@ViewChildren('allExperiences') allExperienceLoad: QueryList<any>;
	@ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
	@ViewChild(GoogleMap, { static: false }) map: GoogleMap;
	@ViewChild(GoogleMap, { static: false }) googleMap: GoogleMap;
	mapDragEndEvent: google.maps.MapsEventListener;
	private _picker: BsDatepickerDirective;
	isBrowser: boolean;
	searchKeyword: string;
	submitted: boolean = false;
	page: number = 1;
	last_page: number = 0;
	totalRecord: number = 0;
	current_page: number = 0;
	max_quantity_count: number = 10;
	purchaseExpID: any;
	purchaseExpSlug: any;
	purchaseExpTitle: any;
	purchaseExpImage: any;
	purchaseExpType: any;
	purchaseExpPrice: any;
	purchaseExpQuantity: any;
	purchaseExpVerID: any;
	purchaseExpTax: any;
	imageUrl: any;
	main_image_url: string = '';
	categoryList: any = [];
	locationRow: any = {};
	selectedCountry: any = {};
	resultContent: any = [];
	result: any = [];
	slug = '';
	base_website_url = '';
	image_url = '';
	isLoading = false;
	noRecordFound = false;
	scrollEnable = false;
	isUserLogin: boolean = false;
	searchSort: boolean = false;
	tokenkey: any = ''
	showRegChkmark: boolean = false;
	keyword = 'value';
	data: any = [];
	type = '';
	search_id = '';
	select_data: any = '';
	location_list: any = '';
	travel_name: any = '';
	category_id: number = 0;
	selected_country_id: number = 449;
	country_id: number;
	selected_state_id: number = 0;
	price_filter_search: any = {};
	price_filter_options: any = {};
	order_by: any = '';
	order: any = '';
	category_name: any = '';
	amount_value: any = '';
	subscription: Subscription;
	search_type: string = '';
	authUser: any;
	experienceDetails: any = '';
	data_for_dropdown_in_popup: any = '';
	record_id: any = 0
	record_slug: any = ""
	record_title: any = ""
	record_image: any;
	record_price: any = 0;
	record_is_buy_for_yourself: any = 0;
	record_veriation_id: any = 0;
	record_type: any;
	certificate_data: any = '';
	country_list: any = [];
	state_List: any = [];
	city_List: any = [];
	clickCart: any = "";
	start_date: any = ''
	end_date: any
	base_url: any = '';
	is_booking: number = 0;
	dateCustomClasses: DatepickerDateCustomClasses[];
	minDate = new Date();
	maxDate: Date
	selected_date = '';
	city_avail: any = '';
	state_avail: any = '';
	country_avail: any = ''
	check_current_route: any = '';
	country_name: any = '';
	city_id: number = 0;
	selected_country_id_at_first: any = '';
	autocomplete_search: string;
	autocompleteExpResults: any = [];
	save_filter_event: any = "";
	autocompleteData: any = [];
	testDiv: any;
	total_exp: any;
	selected_people: any = 0
	modelChanged: Subject<any> = new Subject<any>();
	modelChanged2: Subject<any> = new Subject<any>();
	location_travel: number = globalConstant.default_country;
	location: any = 0
	resultExp: any = [];
	public fields: Object = { groupBy: 'category', value: 'value' };
	selectedDateRange: any = []
	is_offset: any = '';
	exp_pos: any = '';

	enable_rfp_225: any = globalConstant.ENABLE_RFP_225;
	view_on_map: boolean = false;
	mapview: any;

	currentIW: any = '';
	previousIW: any = '';
	pageSize: number = 20;
	latitude: any;
	longitude: any;
	search_with_map: boolean = false;
	googlemap: any;
	lat_long: any = '';
	fitbounds: boolean = false;
	map_zoom = 6;
	circleData: any;

	view_exp: boolean = false;
	at_home: boolean = false;

	enable_rfp_255: any = globalConstant.ENABLE_RFP_255;
	snipLinks: any = [];

	isCookies: boolean;
	locationContent: any = [];
	displayState: boolean = false;
	title_search: any = "";
	autocomplete_search_to: any;
	exp_slug: any;
	isOpenDatePickerMobile: any = false;
	isOpenDatePicker: boolean = false;
	showRecentSearches: boolean = false;
	searchHistory: any[] = [];
	searchHistorySave: any[] = []
	nearBySearch: any = {};
	zoom: number;
	private geoCoder;
	exp_image_url: string = '';
	location_image_url: string = '';
	category_image_url: string = '';
	city: string;
	selectedNearby: any = false;
	iplocation: any;
	isValueSelectedOrEntered: boolean = false;
	enteredOrSelectedValue: any;
	isDateChanged: boolean = false;
	previousDateRange: Date[] | null = null;
	isInitialLoad: boolean = true;
	title: any;
	displayedContent: any[] = [];
	initialDisplayCount: number = 4;
	loadCount: number = 8;
	ocationContent: any[] = [];
	filteredContent: any[] = [];
	isMobile: boolean;
	searchedItem: any;
	myLatLng = { lat: 63.5888, lng: 154.4931 };

	mapOptions: google.maps.MapOptions = {
		//   center:this.myLatLng,
		zoom: 4
	};
	// markerOptions = { draggable: true };
	markerPosition: any;
	selectedMarker: any;
	groupedData: any[] = [];
	filteredGroups: any[] = [];
	Query: any;
	isDataLoading: boolean = false;
	isRendering: boolean = true;
	gridView: boolean = true;
	MAP: any;
	@ViewChildren('videoElement') videos!: QueryList<ElementRef<HTMLVideoElement>>;
	observer!: IntersectionObserver;
	isBoat: boolean;
	@ViewChild('autoCompleteRef') autoComplete!: AutoComplete;
    enteredValue: string = "";

	@HostListener('window:scroll', [])
	onWindowScroll() {
		if (this.isBrowser && this.view_on_map == false) {
			var windowScrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
			if (this.scrollEnable && this.isDataLoading === false) {
				if (windowScrollTop > (document.documentElement.scrollHeight - window?.innerHeight) - 70) {
					if (this.page <= this.last_page) {
						// Check for valid start_date and end_date
						const startDateParam = this.start_date !== undefined && this.start_date !== null ? this.start_date : '';
						const endDateParam = this.end_date !== undefined && this.end_date !== null ? this.end_date : '';

						this._location.replaceState('/location-region/' + this.slug +
							"?page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking +
							(this.is_booking > 0 ? ("&start_date=" + startDateParam + "&end_date=" + endDateParam) : ''));
						this.is_offset = 0;
						this.getAllExperienceData();
					}
				}
			}
		}
	};

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		// this.stickyMap();
	}

	ngAfterViewInit() {
		this.allExperienceLoad.changes.subscribe(t => {
			if (this.is_offset == 1 && this.exp_pos > 0) {
				if (this.isBrowser) {
					var elmnt = document.getElementById(this.exp_pos);
					if (elmnt)
						elmnt.scrollIntoView();
				}
			}
		});

		this.showVideo();

	}

	buildThresholdList() {
		const thresholds = [];
		const numSteps = 20;
		for (let i = 1; i <= numSteps; i++) {
			thresholds.push(i / numSteps);
		}
		return thresholds;
	}

	showVideo() {
		if (this.isBrowser) {
			const options: IntersectionObserverInit = {
				root: null,
				threshold: this.buildThresholdList()
			};

			this.ngZone.runOutsideAngular(() => {
				this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

				this.videos.forEach(videoRef => {
					const video = videoRef.nativeElement;
					video.preload = 'metadata'; // prevent network overload
					video.pause(); // ensure all are paused initially
					this.observer.observe(video);
				});

				// Also re-evaluate on resize/scroll in case layout shifts
				window.addEventListener('resize', this.recheckObserver);
				window.addEventListener('scroll', this.recheckObserver, true);
			});
		}
	}

	private handleIntersect(entries: IntersectionObserverEntry[]) {
		let maxRatio = 0;
		let mostVisibleVideo: HTMLVideoElement | null = null;

		entries.forEach(entry => {
			const ratio = entry.intersectionRatio;
			if (ratio > maxRatio) {
				maxRatio = ratio;
				mostVisibleVideo = entry.target as HTMLVideoElement;
			}
		});

		if (mostVisibleVideo) {
			this.videos.forEach(videoRef => {
				const video = videoRef.nativeElement;
				if (video === mostVisibleVideo) {
					video.play().catch(() => { });
				} else {
					video.pause();
				}
			});
		}
	}

	private recheckObserver = () => {
		this.videos.forEach(videoRef => {
			const video = videoRef.nativeElement;
			this.observer.unobserve(video);
			this.observer.observe(video);
		});
	};


	experiencefindUpdate = new Subject<string>();


	showMore = false;
	modalRef?: BsModalRef;
	stateModalRef?: BsModalRef;
	siteUrl: String = globalConstant?.WEBSITE_URL;
	pageUrl: any = '';
	isMobileView: any;
	baseUrl: string = '';

	constructor(private experience: Experience,
		private breakpointObserver: BreakpointObserver,
		private router: Router,
		private addexperience: AddExperience,
		private canonicalService: CanonicalService,
		private locationService: LocationService,
		private cartService: CartService,
		private mainService: MainService,
		private messageService: MessageService,
		private ExpDetailService: ExperienceDetailsService,
		public findCoupleService: FindCouple,
		private activatedRoute: ActivatedRoute,
		@Inject(PLATFORM_ID) platformId: Object,
		public datePipe: DatePipe,
		private titleService: Title,
		private metaService: Meta,
		private _location: Location,
		public toastr: ToastrService,
		private analyticsService: AnalyticsService,
		private ticketEvaluation: TicketEvaluation,
		private visitorService: VisitorsService,
		private filterService: FilterService,
		private ngZone: NgZone,
		public renderer: Renderer2,
		private modalService: BsModalService) {
		let currenturl = this.router.url;
		let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
		const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
		this.canonicalService.setCanonical(canonicalUrl);
		this.pageUrl = canonicalUrl;

		this.breakpointObserver
			.observe([Breakpoints.Handset])
			.subscribe(result => {
				this.isMobileView = result.matches;
				this.gridView = !this.isMobileView
			});

		//this.base_url = location.origin+'/experiences/';

		this.isBrowser = isPlatformBrowser(platformId);
		if (this.isBrowser) {
			this.isMobile = window?.innerWidth <= 768;
			this.baseUrl = window?.location?.hostname;
			if (localStorage.getItem('authUser')) {
				this.tokenkey = localStorage.getItem('login_token');
				this.authUser = JSON.parse(localStorage.getItem('authUser'));
				this.isUserLogin = true;
			}
			else {
				this.tokenkey = ''
				this.isUserLogin = false
			}
		}

		this.router.routeReuseStrategy.shouldReuseRoute = () => false;

		this.slug = this.router?.url?.split("/")[2];
		if (this.router?.url?.split("/")[2]?.split("?")) {
			this.slug = this.router?.url?.split("/")[2]?.split("?")[0];
		} else {
			this.slug = this.router?.url?.split("/")[2];
		}
		this.check_current_route = this.router?.url?.split("/")[1];
		const urlArray = this.router?.url?.split("/");
		const locationPart = urlArray[2];
		const queryParamsIndex = locationPart.indexOf('?');
		if (queryParamsIndex !== -1) {
			this.title = locationPart.substring(0, queryParamsIndex);
		} else {
			this.title = locationPart;
		}

		// this.titleService.setTitle(this.slug+globalConstant.SITE_TITLE_SEPARATOR+globalConstant.SITE_TITLE);
		this.experiencePageContent();

		this.activatedRoute.queryParams.subscribe(params => {

			if (params['view_exp']) {
				this.view_exp = params['view_exp'];
			}

			if (params['is_booking']) {
				this.is_booking = parseInt(params['is_booking']);
			}
			this.selectedDateRange = []
			if (params['start_date']) {
				this.start_date = params['start_date'];
				if (this.start_date) {

					this.selectedDateRange.push(this.datePipe.transform((this.start_date), 'MM-dd-yyyy'))
				}
			}
			if (params['end_date']) {
				this.end_date = params['end_date'];
				if (this.end_date) {
					this.selectedDateRange.push(this.datePipe.transform((this.end_date), 'MM-dd-yyyy'))
				}
			}
			if (params['latitude']) {
				this.latitude = params['latitude'];
			}
			if (params['longitude']) {
				this.longitude = params['longitude'];
			}
			if (this.isBrowser) {
				if (localStorage.getItem('price_filter_location')) {
					let priceFilterObj = JSON.parse(localStorage.getItem('price_filter_location'));
					localStorage.removeItem('price_filter_location');
					this.changePriceFilter(priceFilterObj.operator, priceFilterObj.value, 1);
					if (params['page']) {
						this.page = parseInt(params['page']);
						if (this.page == 0) {
							this.page = 1;
						}
					}
					if (params['exp_pos']) {
						this.exp_pos = parseInt(params['exp_pos']);
						this.is_offset = 1;
					} else {
						if (this.isBrowser) {

							window.scrollTo(0, 0);
						}
					}
					this.getAllExperienceData();
				} else {
					if (params['page']) {
						this.page = parseInt(params['page']);
						if (this.page == 0) {
							this.page = 1;
						}
					}
					if (params['exp_pos']) {
						this.exp_pos = parseInt(params['exp_pos']);
						this.is_offset = 1;
					} else {
						if (this.isBrowser) {

							window.scrollTo(0, 0);
						}
					}
					this.getAllExperienceData();
				}
			}
		});

		const now = new Date();
		this.dateCustomClasses = [
			{ date: now, classes: ['bg-warning'] },
		];

		this.modelChanged.pipe(debounceTime(100)).subscribe(sub => {
			if (sub.text.replace(/^\s+|\s+$/gm, '').length >= 1)
				this.onFiltering_after_debounce(sub);
		});

		if (this.isBrowser) {
			window.addEventListener('resize', this.updateScreenSize.bind(this));
		}

		this.modelChanged2.pipe(debounceTime(100)).subscribe(query => {
			if (query.trim().length >= 1) {
				this.onFilteringAfterDebounce(query);
			}
		});
	}


	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}

	public loadJsScript(renderer: Renderer2, src: string, isAsync: boolean = true, isDefer: boolean = true): HTMLScriptElement {
		if (this.isBrowser) {
		  const script = renderer.createElement('script');
		  script.type = 'text/javascript';
		  script.src = src;
		  script.id = 'yotpo_id'
		  if (isAsync) {
			script.async = true;
		  }
		  if (isDefer) {
			script.defer = true;
		  }
		  renderer.appendChild(document.body, script);
		  return script;
		}
	  }


	ngOnInit() {
		this.getCategoryList();
		this.getCountryList();
		if (this.isBrowser) {
			this.base_website_url = window.location.origin;
		}
		this.experiencefindUpdate.pipe(
			debounceTime(1000),
			distinctUntilChanged())
			.subscribe(value => {
				this.select_data = value
				if (this.data.length > 0) {
					for (let i = 0; i < this.data.length; i++) {
						if (this.data[i].value == this.select_data.value) {
							this.type = this.data[i].type;
							this.search_id = this.data[i].id;
						}
					}
				}
				this.amount_value = '';
				this.category_name = '';
				this.result = [];
				this.last_page = 0;
				this.current_page = 0;
				this.page = 1;
				this.category_id = 0;
				this.price_filter_search = {};
				this.order_by = '';
				this.order = '';
				this.noRecordFound = false;
				this.isLoading = false;
				// this.getAllExperienceData();
			});

		this.experience.eastern_us().subscribe(res => {
			this.location_list = res.data;
			for (let i = 0; i < this.location_list.length; i++) {
				if (this.location_list[i].slug == this.slug) {
					this.travel_name = this.location_list[i].name;
				}
			}
		});

		this.experience.get_circle_section().subscribe(res => {
			this.circleData = res.data;
		});

		/* this.messageService.sendAutocompleteSearchParameterMessage({'search_type':'location-region','location_slug':this.slug}); */
		if (this.isBrowser) {

			if (document.getElementById("mapParent")) {
				this.testDiv = document.getElementById("mapParent")?.offsetTop;
			}
		}


		this.isCookies = this.getCookie('acceptCookies') !== "";
		if (this.isBrowser) {

			this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
		}
	}

	updateScreenSize() {
		if (this.isBrowser) {
			this.isMobile = window.innerWidth <= 768;
		}
	}

	getCookie(data) {
		if (this.isBrowser) {
			let name = data + "=";
			let ca = document.cookie?.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}
	}

	saveRecentSearch(newSearch) {
		if (this.isBrowser) {

			let searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
			if (newSearch?.id !== null) {
				searchHistory = searchHistory.filter(exp => exp?.title !== newSearch?.title);
			} else {
				searchHistory = searchHistory.filter(exp => !(exp.id === newSearch?.id && exp?.type === newSearch?.type));
			}

			// Add the new search entry to the top
			if (Object.keys(newSearch)?.length > 0) {
				searchHistory.unshift(newSearch);
			}
			// Ensure only the last 5 experiences are stored
			if (searchHistory?.length > 5) {
				searchHistory = searchHistory.slice(0, 5);
			}

			this.searchHistorySave = searchHistory;
			localStorage.setItem('searchHistory', JSON.stringify(this.searchHistorySave));
		}
	}


	experiencePageContent() {
		this.experience.getLocationPageContent(this.slug).subscribe(res => {
			if (res.message == 'Success' && (res.data.location_type == 0 || res.data.location_type == 1)) {
				this.resultContent = res?.data;
				this.imageUrl = res?.image_url
				if (this.resultContent && this.resultContent.name !== undefined && this.resultContent.name !== null && this.resultContent.name !== '') {
					this.title_search = this.resultContent.name;
				}
				else {
					this.title_search = this.title;
				}
				this.locationContent = this.resultContent?.sub_categoies;
				if (this.locationContent !== undefined && this.locationContent !== null) {
					this.displayedContent = this.locationContent;
					// this.displayedContent = this.locationContent.slice(0, this.initialDisplayCount);
					this.filteredContent = this.locationContent;
				}
				if (this.resultContent && !this.resultContent?.parent_id) {
					this.displayState = true;
				} else {
					this.displayState = false;
				}
				if (this.isCookies && this.resultContent.id !== undefined && this.resultContent.id !== null) {
					const newSearch = {
						id: this.resultContent?.id,
						title: this.resultContent.name,
						image_url: this.resultContent?.image,
						params: this.resultContent?.slug,
						city: '',
						type: 'location-list',
						location_type: this.resultContent?.type

					};
					this.saveRecentSearch(newSearch);
				} else if (this.isCookies && !this.resultContent.id) {
					if (this.isBrowser) {

						const searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
						this.searchHistorySave = searchHistory;
					}
				}
				this.main_image_url = res.image_url;
				this.locationRow = res.data;
				this.snipLinks = res.snip_links;
				this.addMetaTags();

				if (this.videoElement) {
					this.videoElement.nativeElement.load(); // play video
				}

				if (this.locationRow && typeof this.locationRow.parent_id != "undefined") {
					/** If Given Url slug is state  **/
					if (this.locationRow.parent_id > 0) {
						// Url slug is state because parent id exists.
						this.selected_country_id = this.locationRow.parent_id;
						this.selected_country_id_at_first = this.locationRow.parent_id;
						this.selected_state_id = this.locationRow.id;
					} else {
						// Url slug is country.  
						this.selected_country_id = this.locationRow.id;
						this.selected_country_id_at_first = this.locationRow.id;
						this.selected_state_id = 0;
					}

					this.latitude = Number(this.resultContent.latitude);
					this.longitude = Number(this.resultContent.longitude);
					this.map_zoom = Number(this.resultContent.map_zoom);
					this.country_name = 3;
					this.getStateList(this.selected_country_id);
					this.getCityList(this.selected_state_id);
				}
			} else {
				this.router.navigate([`/location-region/${res.data.parent_location_slug}/${this.slug}`]);
			}
		});
	}

	filterContent(searchTerm: string) {
		const trimmedSearchTerm = searchTerm.trim().toLowerCase();
		this.filteredContent = this.locationContent.filter(city => city.name.toLowerCase().includes(trimmedSearchTerm));
		this.displayedContent = this.filteredContent.slice(0, this.initialDisplayCount);
	}

	getCategoryList() {
		var categoryFilter = { 'category_for': 'experience', 'type': 'main-category' };
		this.mainService.get_categories(categoryFilter).subscribe(res => {
			this.categoryList = res.data;
		});
	}

	onCategorySelect(value, cat_name) {
		this.search_id = '';
		this.type = "";
		this.current_page = 0;
		this.category_id = value;
		this.category_name = cat_name;
		this.result = [];
		this.searchSort = true;
		this.page = 1;
		this.getAllExperienceData(); // calls function get experience data.
	}

	changePriceFilter(operator = "", value = "", type) {
		this.search_id = '';
		this.type = "";
		this.current_page = 0;
		this.amount_value = type;
		this.result = [];
		var filter = { 'lte': '', 'gte': '' };
		if (operator == "lesser") {
			filter.lte = value;
			filter.gte = "";
		} else if (operator == 'between') {
			var val = value?.split("-");
			filter.gte = val[0];
			filter.lte = val[1];
		} else if (operator == 'greater') {
			filter.lte = "";
			filter.gte = value;
		}

		this.price_filter_options = JSON.stringify({ 'operator': operator, 'value': value });

		/* if(locationChange == 0){
			let priceFilterObj 	=	JSON.stringify({'operator':operator, 'value':value});
			localStorage.setItem('price_filter_location', priceFilterObj);
		} */


		this.price_filter_search = filter;

		this.searchSort = true;

		this.getAllExperienceData(); // calls function get experience data.
	}

	tab_change(is_booking = 0) {

		if (this.is_booking == is_booking) {
			return;
		}
		this.at_home = false;
		this.currentIW = '';
		this.previousIW = '';
		this.is_booking = is_booking;
		this.page = 1;
		if (is_booking == 0) {
			this.end_date = ''
			this.start_date = ''
			this.selectedDateRange = []
		} else if (is_booking == 2) {
			if (this.start_date && this.end_date) {

				this.selectedDateRange[0] = this.start_date
				this.selectedDateRange[1] = this.end_date
			} else {
				this.selectedDateRange = []
			}
			this.start_date = this.start_date ? this.datePipe.transform((this.start_date), 'yyyy-MM-dd') : ''
			this.end_date = this.end_date ? this.datePipe.transform((this.end_date), 'yyyy-MM-dd') : ''
		} else {
			if (this.start_date && this.end_date) {

				this.selectedDateRange[0] = this.start_date
				this.selectedDateRange[1] = this.end_date
			} else {
				this.selectedDateRange = []
			}
			!this.selectedDateRange?.length ? this.start_date = '' : this.start_date
			!this.selectedDateRange?.length ? this.end_date = '' : this.end_date
		}
		this.current_page = 1;
		this.last_page = 1;
		this.exp_pos = 0;
		this.result = [];
		this.certificate_data = [];
		let setUrl = '/location-region/' + this.slug +
			"?page=" + this.page + "&exp_pos=" + this.exp_pos + "&is_booking=" + is_booking +
			(is_booking > 0 ? ("&start_date=" + this.start_date + "&end_date=" + this.end_date) : '');
		this._location.replaceState(setUrl);
		this.getAllExperienceData();
	}


	map_view(mapview) {
		this.view_on_map = mapview.target.checked;
		this.currentIW = '';
		this.previousIW = '';
		this.page = 1;
		this.current_page = 1;
		this.last_page = 1;
		this.result = [];
		this.at_home = false;
		//this.getAllExperienceData();
		if (this.isBrowser && this.view_on_map) {
			this.search_with_map = true;
			// this.searchWithMap(1);
		} else {
			this.search_with_map = false;
			this.lat_long = "";
		}
		this.getAllExperienceData();
	}

	searchWithMap(event) {
		//this.search_with_map = event.target.checked;
		this.search_with_map = event;
		this.fitbounds = false;
		if (this.search_with_map) {
			this.mapDragEndEvent = this.googleMap.googleMap.addListener('dragend', () => {
				this.currentIW = '';
				this.previousIW = '';
				var bounds = this.googleMap.getBounds();
				this.lat_long = bounds.toJSON();
				this.page = 1;
				this.current_page = 1;
				this.last_page = 1;
				this.getAllExperienceData();
			})

			// google.maps.event.addListener(this.googlemap, 'dragend', () => {
			// 	this.currentIW = '';
			// 	this.previousIW = '';
			// 	var bounds = this.googlemap.getBounds();
			// 	this.lat_long = bounds.toJSON();
			// 	this.page = 1;
			// 	this.current_page = 1;
			// 	this.last_page = 1;
			// 	this.getAllExperienceData();
			// });

			this.currentIW = '';
			this.previousIW = '';
			let bounds = this.googlemap.getBounds();
			this.lat_long = bounds.toJSON();
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
			this.getAllExperienceData();

		} else {
			this.mapDragEndEvent.remove();
			// google.maps.event.clearListeners(this.googlemap, 'dragend');
			//this.fitbounds = true;
			this.currentIW = '';
			this.previousIW = '';
			//this.page	=	1;
			//this.current_page	=	1;
			//this.last_page	=	1;
			this.lat_long = '';
			//this.result	=	[];
			//this.getAllExperienceData();
		}
	}

	searchWithMapDragEnd(event) {
		this.search_with_map = event;
		this.fitbounds = false;
		if (this.search_with_map) {
			this.mapDragEndEvent = this.googleMap.googleMap.addListener('dragend', () => {
				this.currentIW = '';
				this.previousIW = '';
				var bounds = this.googleMap.getBounds();
				this.lat_long = bounds.toJSON();
				this.page = 1;
				this.current_page = 1;
				this.last_page = 1;
				this.getAllExperienceData();
			})

		} else {
			this.mapDragEndEvent.remove();
			// google.maps.event.clearListeners(this.googleMap, 'dragend');
			//this.fitbounds = true;
			this.currentIW = '';
			this.previousIW = '';
			//this.page	=	1;
			//this.current_page	=	1;
			//this.last_page	=	1;
			this.lat_long = '';
			//this.result	=	[];
			//this.getAllExperienceData();
		}
	}

	map_image_enter(index: any) {
		//let div_sec = document.querySelector("div[aria-label=Map]");
		//let img_css = div_sec.children[0].children[3].children[index+1].children[0];
		//let marker = document.querySelector("#marker_"+index);

		let image = this.result[index].map_image_url;
		this.result[index].map_image = { url: image, scaledSize: { width: 50, height: 50 } };
		this.result[index].zindex = 8;
	}

	map_image_out(index: any) {
		let image = this.result[index].map_image_url;
		this.result[index].map_image = { url: image, scaledSize: { width: 35, height: 35 } };
		this.result[index].zindex = 1;
	}

	onMouseClick(index: any, marker: MapMarker, infoWindow: MapInfoWindow) {
		let image = this.result[index].map_image_url;
		this.result[index].map_image = { url: image, scaledSize: { width: 36, height: 36 } };

		// let marker 	=	infoWindow.hostMarker;
		//let pixelOff 	=	this.getInfowindowOffset(this.googlemap, {'lng':function(){return marker.longitude}, 'lat':function(){return marker.latitude}});
		//let pixelOff 	=	this.getInfowindowOffset(this.googlemap, marker); 
		//infoWindow._setInfoWindowOptions({ pixelOffset: pixelOff }); 
		// this.selectedMarker = marker
		infoWindow.open(marker);

		if (this.previousIW) {
			this.currentIW = this.infoWindow;
			this.previousIW.close();
		}
		this.previousIW = this.infoWindow;

	}

	infoWindowClose(infoWindow: MapInfoWindow) {
		infoWindow.close();
	}
	getInfowindowOffset(map, marker) {
		var center = this.getPixelFromLatLng(map.getCenter()),
			point = this.getPixelFromLatLng(marker),
			quadrant = "",
			offset;

		quadrant += (point.y > center.y) ? "b" : "t";
		quadrant += (point.x < center.x) ? "l" : "r";
		if (quadrant == "tr") {
			//offset = new google.maps.Size(-160, 250);
			offset = new google.maps.Size(-180, 420);
		} else if (quadrant === "tl") {
			offset = new google.maps.Size(180, 420);
			//offset = new google.maps.Size(1500, 1500);
		} else if (quadrant === "br") {
			//offset = new google.maps.Size(-140, 30);
			offset = new google.maps.Size(-150, 60);
		} else if (quadrant === "bl") {
			offset = new google.maps.Size(150, 60);
		}
		return offset;
	};

	getPixelFromLatLng(latLng) {
		var projection = this.googlemap.getProjection();
		var point = projection.fromLatLngToPoint(latLng);
		return point;
	};

	pageChanged(eve) {
		this.currentIW = '';
		this.previousIW = '';
		this.page = eve;
		this.current_page = eve;
		//this.result	=	[];
		if (this.search_with_map) {
			this.fitbounds = false;
		} else {
			this.fitbounds = true;
		}
		this.getAllExperienceData();
	}


	/*centerChange(event){
		  this.lat = event.lat;
		  this.lng = event.lng;
	}*/

	zoomChange(event) {
		if (this.search_with_map) {
			this.currentIW = '';
			this.previousIW = '';
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
			var bounds = this.googlemap.getBounds();
			this.lat_long = bounds.toJSON();
			var center = this.googlemap.getCenter();
			this.latitude = center.lat();
			this.longitude = center.lng();
			this.getAllExperienceData();
		}
	}

	public mapReady(map) {
		this.googlemap = map;
		//this.searchWithMap(event);
		google.maps.event.addListener(this.googlemap, 'dragend', () => {
			this.currentIW = '';
			this.previousIW = '';
			var bounds = this.googlemap.getBounds();
			this.lat_long = bounds.toJSON();
			var center = this.googlemap.getCenter();
			this.latitude = center.lat();
			this.longitude = center.lng();
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
			this.getAllExperienceData();
		});
		//const bounds = new google.maps.LatLngBounds();
		/*for (const mm of this.result) {
		  bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
		}*/
		//map.fitBounds(bounds);

		map.setOptions({
			zoomControl: 'true',
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_LEFT
			}
		});
	}

	nearby(isMobile) {
		this.selectedNearby = true;
		this.visitorService.getCurrent_location_nearBy().then((res: any) => {
			if (res.address && res.address.address_components) {
				let city = '';
				let addressComponents = res.address.address_components;

				// Iterate through address components to find the city
				for (let i = 0; i < addressComponents.length; i++) {
					let types = addressComponents[i].types;

					if (types.includes('locality')) {
						city = addressComponents[i].long_name;
						break;
					} else if (!city && types.includes('administrative_area_level_3')) {
						city = addressComponents[i].long_name;
					} else if (!city && types.includes('administrative_area_level_2')) {
						city = addressComponents[i].long_name;
					}
				}

				if (city) {
					this.city = city;
				}
				if (typeof addressComponents[3] != 'undefined' && addressComponents[3].long_name != 'undefined') {
					let iploc = {};
					iploc['region'] = addressComponents[3].long_name;
					this.iplocation = iploc;
					this.autocomplete_search_to = this.city;
					if (this.isBrowser) {
						let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue');
						if (idElement && idElement.querySelector('input')) {
							idElement.querySelector('input').value = this.city;
						}
					}
					isMobile ? this.isOpenDatePickerMobile = true : this.isOpenDatePicker = true;
					this.latitude = res.lat;
					this.longitude = res.long;
				}
			}
		}).catch((err) => {
			console.error('Error in nearby function:', err);
			if (err.code === 1) {  // PERMISSION_DENIED
				this.toastr.errorToastr("Enable location to see nearby.", 'Error!');

			} else {
				this.toastr.errorToastr("An error occurred while fetching location.", 'Error!');
			}
		});
	}

	getAllExperienceData() {
		if ((this.last_page >= this.page || this.last_page == 0) && this.current_page <= this.last_page) {
			//if((this.last_page >= this.page || this.last_page == 0) && this.current_page<=this.last_page){
			interface Item {
				item_id: number;
				item_name: string;
				discount: number;
				item_brand: string;
				item_category: string;
				item_list_id: any;
				item_list_name: string;
				price: number;
				quantity: number;
				// Add other properties as needed
			}
			// this.isLoading = true;
			this.isDataLoading = true;
			this.isRendering = true;
			let requestbody = {
				'location_slug': this.slug, 'page': this.page, 'search_id': this.search_id,
				'type': this.type, 'category_id': this.category_id,
				'price_option': this.price_filter_search, 'order_by': this.order_by,
				'order': this.order, 'is_booking': this.is_booking,
				'start_date': this.start_date,
				'end_date': this.end_date,
				'is_offset': this.is_offset, 'lat_long': this.lat_long, 'view_on_map': this.view_on_map,
				'latitude': this.latitude, 'longitude': this.longitude,
				'at_home': this.at_home,
				'title': this.searchedItem
			};
			this.experience.getExperienceByLocation1(requestbody, this.tokenkey).subscribe(res => {
				if (res.response == 'success') {
					this.isLoading = false;
					this.isDataLoading = false;
					this.isRendering = false;
					let gtag_items: any[] = [];
					if (this.page == 1) {
						this.result = [];
					}

					if (this.is_booking == 2) {

						if (res.data.events && res.data.events.length > 0) {
							var responseData = res.data.events;


							var paginationData = res.data.pagination;
							for (let i = 0; i < Object.keys(responseData).length; i++) {
								responseData[i].map_image = { url: responseData[i].image_url, scaledSize: { width: 35, height: 35 } };
								responseData[i].zindex = 1;

							}

							if (this.view_on_map) {
								this.result = responseData;

								this.getExpQuantity(this.result);
								if (this.isBrowser) {
									// setTimeout(function(){
									// 		var stickySidebar = new StickySidebar("#stickyMap", {
									// 			topSpacing: 0
									// 		});	
									// 	},4000);

								}
							} else {
								this.result = [...this.result, ...responseData];

								this.getExpQuantity(this.result);

							}

							this.pageSize = paginationData.per_page;
							this.totalRecord = paginationData.total_entries;
							this.last_page = paginationData.last_page;
							this.scrollEnable = true;
							setTimeout(() => {
								if (this.isBrowser) {
								  this.loadJsScript(this.renderer, "https://staticw2.yotpo.com/vbWht62N5vShfWTnel3ir0s0imPG2iXJJ4kRoSlR/widget.js", true, true);
								}
							  }, 100);
							if (!this.view_on_map) {
								this.current_page = paginationData.current_page + 1;
								this.page += 1;
							}
						} else {
							this.result = [];
							this.scrollEnable = false;
						}
					} else {
						if (res.data.data.length > 0) {
							let favAndInstantArr = [];
							let instantArr = [];
							let favArr = [];
							let bothNoneArr = [];

							res?.data?.data.forEach(item => {
								if (item.favorite == 1 && item.instant_book == 1) {
									favAndInstantArr.push(item);
								} else if (item.favorite == 1 && item.instant_book == 0) {
									favArr.push(item);
								} else if (item.favorite == 0 && item.instant_book == 1) {
									instantArr.push(item);
								} else if (item.favorite == 0 && item.instant_book == 0) {
									bothNoneArr.push(item);
								}
							});
							if (favAndInstantArr?.length > 0) {
								favAndInstantArr.forEach((item, i) => {
									const j = Math.floor(Math.random() * (i + 1));
									[favAndInstantArr[i], favAndInstantArr[j]] = [favAndInstantArr[j], favAndInstantArr[i]];
								})
							}
							if (favArr?.length > 0) {
								favArr.forEach((item, i) => {
									const j = Math.floor(Math.random() * (i + 1));
									[favArr[i], favArr[j]] = [favArr[j], favArr[i]];
								})
							}
							if (instantArr?.length > 0) {
								instantArr.forEach((item, i) => {
									const j = Math.floor(Math.random() * (i + 1));
									[instantArr[i], instantArr[j]] = [instantArr[j], instantArr[i]];
								})
							}
							if (bothNoneArr?.length > 0) {
								bothNoneArr.forEach((item, i) => {
									const j = Math.floor(Math.random() * (i + 1));
									[bothNoneArr[i], bothNoneArr[j]] = [bothNoneArr[j], bothNoneArr[i]];
								})
							}
							var responseData: any = [...favAndInstantArr, ...favArr, ...instantArr, ...bothNoneArr];
							for (let i = 0; i < Object.keys(responseData).length; i++) {
								responseData[i].map_image = { url: responseData[i].image_url, scaledSize: { width: 35, height: 35 } };
								responseData[i].zindex = 1;
								let item: Item = {
									item_id: responseData[i]?.id,
									item_name: responseData[i]?.title,
									discount: 0,
									item_brand: responseData[i]?.company_name,
									item_category: globalConstant?.gtag_item_category,
									item_list_id: this.slug + "_experiences",
									item_list_name: this.slug + "-experiences",
									price: responseData[i]?.regular_price,
									quantity: globalConstant?.gtag_quantity
								}
								gtag_items.push(item)

								if (responseData[i].variations_data.length > 0) {
									for (let k = 0; k < responseData[i].variations_data.length; k++) {
										if (responseData[i].variations_data[k].slug == 'buy-for-yourself') {
											responseData[i].is_buy_for_yourself = 1;
											responseData[i].buy_for_yourself_veriation_id = responseData[i].variations_data[k].id;
											break;
										} else {
											responseData[i].is_buy_for_yourself = 0;
											responseData[i].buy_for_yourself_veriation_id = 0;
										}
									}
								} else {
									responseData[i].is_buy_for_yourself = 0;
									responseData[i].buy_for_yourself_veriation_id = 0;
								}
							}

							if (this.view_on_map) {
								this.result = responseData;

								this.getExpQuantity(this.result);
								if (this.isBrowser) {
									// setTimeout(function(){
									// 	var stickySidebar = new StickySidebar("#stickyMap", {
									// 		topSpacing: 0
									// 	});	
									// },4000);							
								}
							} else {
								this.result = [...this.result, ...responseData];
								this.getExpQuantity(this.result);
							}
							this.certificate_data = res.certificate_data;
							this.image_url = res.experience_image_url;
							this.pageSize = res.data.per_page;
							this.scrollEnable = true;
							this.totalRecord = res.data.total;
							this.total_exp = Object.keys(this.result).length;
							if (this.totalRecord == 0) {
								this.noRecordFound = true;
							} else {
								this.noRecordFound = false;
							}
							this.last_page = res.data.last_page;

							if (!this.view_on_map) {
								this.current_page = res.data.current_page + 1;
								this.page += 1;
							}

							this.searchSort = false;
						}
						else {
							this.result = [];
							this.certificate_data = res.certificate_data;
							this.scrollEnable = false;
						}

					}

					let gtagData = {
						item_list_id: this.slug + "_experiences",
						item_list_name: this.slug + "-experiences",
						items: gtag_items
					}
					if(this.baseUrl && (this.baseUrl == 'spurexperiences.com' || this.baseUrl == 'spurexperiences.com/' 
					|| this.baseUrl == 'https://spurexperiences.com/' || this.baseUrl == 'https://spurexperiences.com')) {
					this.analyticsService.analyticsData('view_item_list', gtagData)
			     	}

					if (this.isBrowser) {
						if (this.view_exp) {
							setTimeout(function () {
								window.scrollTo(0, 1100);
							}, 100);

							this.view_exp = false;
						}
					}

				} else if (res.response == 'error') {
					this.noRecordFound = true;
					this.scrollEnable = false;
				}
				if (this.isBrowser) {
					if (document.getElementById('loader')) {
						document.getElementById('loader').click();	// Loading problem solution on map view when user drag on the map.
					}
				}
				this.isLoading = false;
				this.isDataLoading = false;
				this.isRendering = false;
			});
		}
	}

	/* OPEN ADD TO CART FOR NON LOGGEDIN USERS POPUP */
	openDialog(record, price, type, tax = 0, data: any = '', componentName = 'location-region') {
		let gratuity = record?.gratuity ? record?.gratuity : 0
		//this.close();
		if (data['key']) {

			data['key'] = this.authUser?.role_id == 4 ? ((!record?.for_individual_price || record?.for_individual_price == 0) ? 2 : 1) : data?.key
		}
		if (record?.is_buy_for_yourself == 1) {
			if (this.isBrowser) {
				var element = document.querySelector("body");
				var htmlelement = document.querySelector("html")
				if (element) {
					element.classList.add('overflow');
				}
				if (htmlelement) {
					htmlelement.classList.add('overflow');
				}
			}

			this.clickCart = "overflow_remove"
			var qty = record.alternate_quantity == 1 ? data?.qty : 1;
			if (record.alternate_quantity == 1) {
				var taxValue = ((price * qty) * tax / 100);
				var gratuityValue = ((price * qty) * gratuity / 100);
				this.purchaseExpPrice = price;
			} else {
				if (this.isUserLogin && this.authUser?.role_id != 4) {
					var taxValue = ((price * qty) * tax / 100);
					var gratuityValue = ((price * qty) * gratuity / 100);
					this.purchaseExpPrice = price
				} else {
					if (data?.key > 1 && record?.for_individual_price > 0) {
						var taxValue = (((price * data?.key) * qty) * tax / 100);
						var gratuityValue = (((price * data?.key) * qty) * gratuity / 100);
						this.purchaseExpPrice = price * data?.key
					} else {
						var taxValue = ((price * qty) * tax / 100);
						var gratuityValue = ((price * qty) * gratuity / 100);
						this.purchaseExpPrice = price
					}
				}
			}

			this.purchaseExpID = record?.id;
			this.purchaseExpSlug = record?.slug;
			this.purchaseExpTitle = record?.title;
			this.purchaseExpImage = record?.image_url;
			this.purchaseExpType = type;
			this.purchaseExpVerID = record?.buy_for_yourself_veriation_id;
			this.purchaseExpQuantity = qty;
			this.purchaseExpTax = taxValue;
			let pushedItems = {};
			var cartItems: any = [];
			if (this.isBrowser) {

				if (localStorage.getItem('cart_details')) {
					cartItems = JSON.parse(localStorage.getItem('cart_details'));
				}
			}
			let hasPresentOn = cartItems.find(
				function (el) {
					if (el.product_id === record?.id) {
						return true;
					} else {
						return false;
					}
				}
			);
			if (!hasPresentOn) {
				if (this.authUser && (this.authUser.role_id == 5 || this.authUser.role_id == 1)) {
					pushedItems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name + ' & ' + this.authUser.partner_first_name + ' ' + this.authUser.partner_last_name;
				} else if (this.authUser && this.authUser.role_id == 4) {
					pushedItems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name
				}
				pushedItems['product_id'] = this.purchaseExpID;
				pushedItems['title'] = this.purchaseExpTitle;
				pushedItems['slug'] = this.purchaseExpSlug;
				pushedItems['image'] = this.purchaseExpImage;
				pushedItems['type'] = this.purchaseExpType;
				pushedItems['line_total'] = this.purchaseExpPrice;
				pushedItems['qty'] = this.purchaseExpQuantity;
				pushedItems['variation_id'] = this.purchaseExpVerID;
				pushedItems['tax'] = this.purchaseExpTax;
				pushedItems['gratuity'] = gratuityValue;
				pushedItems['tax_percentage'] = Number(tax);
				pushedItems['gratuity_percentage'] = Number(gratuity);
				pushedItems['at_home'] = record?.at_home;
				pushedItems['instant_ship'] = record?.instant_ship;
				pushedItems['component_name'] = componentName;
				pushedItems['price_label'] = record?.price_label;
				pushedItems['name_label'] = data?.name ? data?.name : '';
				pushedItems['alternate_quantity'] = record.alternate_quantity
				pushedItems['city'] = record.alternate_quantity == 1 ? record?.city : '';
				pushedItems['state'] = record.alternate_quantity == 1 ? record?.state : '';
				pushedItems['people_count'] = record.alternate_quantity == 1 || data?.key ? data?.key : data;
				if (this.authUser) {
					pushedItems['user_id'] = this.authUser.id;
				}
				else {
					pushedItems['user_id'] = 0;
				}
				pushedItems['clickCart'] = this.clickCart;
				cartItems.push(pushedItems);
				this.cartService.sendMessage(JSON.stringify(cartItems));
				if (this.isBrowser) {

					localStorage.setItem('cart_details', JSON.stringify(cartItems));
				}
			} else {
				this.toastr.errorToastr("Already added in your cart.", 'Error!');
			}
		}
		setTimeout(() => {
			if (this.isBrowser) {
				var popupWrapElement = document.querySelector(".cartpopup-wrap");
				if (popupWrapElement) {
					popupWrapElement.classList.add('active');
				}
			}
		}, 100);
	}

	fb(e) {
		e.preventDefault();
		if (this.isBrowser) {
			var facebookWindow = window.open(
				'https://www.facebook.com/sharer/sharer.php?u=' + this.base_website_url + '/experiences&title=Experience',
				'facebook-popup',
				'height=350,width=600'
			);
			if (facebookWindow.focus) {
				facebookWindow.focus();
			}
			return false;
		}
	}

	pinterest(e) {
		e.preventDefault();
		if (this.isBrowser) {
			var pinterestWindow = window.open(
				'http://pinterest.com/pin/create/bookmarklet/?media=url=' + this.base_website_url + '/experiences&title=Experience&is_video=false&description=Experience',
				'pinterest-popup',
				'height=350,width=600'
			);
			if (pinterestWindow.focus) {
				pinterestWindow.focus();
			}
			return false;
		}
	}

	twitter(e) {
		e.preventDefault();
		if (this.isBrowser) {
			var twitterWindow = window.open(
				'http://twitter.com/intent/tweet?status=Experience+' + this.base_website_url + '/experiences',
				'twitter-popup',
				'height=350,width=600'
			);
			if (twitterWindow.focus) {
				twitterWindow.focus();
			}
			return false;
		}
	}


	/* FUNCTION TO ADD/REMOVE TO REGISTRY */
	addToRegistry(exp_id, type, index) {
		this.showRegChkmark = true;
		this.result[index].is_show_ckbx = 1;     // show vebo V image.
		this.addexperience.addExperienceRegistry(exp_id, type, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.messageService.sendTotalMessage(res.data);
				let gtag_items = [{
					item_id: this.result[index]?.id,
					item_name: this.result[index]?.title,
					discount: 0,
					item_brand: this.result[index]?.company_name,
					item_category: globalConstant?.gtag_item_category,
					item_list_id: this.slug + "_experiences",
					item_list_name: this.slug + "-experiences",
					price: this.result[index].regular_price,
					quantity: globalConstant?.gtag_quantity
				}]

				let gtagData = {
					currency: "USD",
					value: this.result[index].regular_price * globalConstant?.gtag_quantity,
					items: gtag_items
				}
				if(this.baseUrl && (this.baseUrl == 'spurexperiences.com' || this.baseUrl == 'spurexperiences.com/' 
				|| this.baseUrl == 'https://spurexperiences.com/' || this.baseUrl == 'https://spurexperiences.com')) {
				this.analyticsService.analyticsData('add_to_wishlist', gtagData)
		    	}
				this.result[index].is_show_ckbx = 0;    // hide vebo V image.
				this.result[index].experience_status_msg = res.data.experience_status_msg;
				this.result[index].add_reg_msg_class = res.data.add_reg_msg_class;
				this.result[index].added_registry_type = res.data.added_registry_type;
				this.result[index].experience_status = res.data.is_registry_status;
				this.result[index].is_registry_status = res.data.is_registry_status;

			} else if (res.response == 'error') {
			}
		});
	}
	/* onChangeSearch(val: string) {
	  this.searchKeyword=val;
	  if(this.searchKeyword=="")
	  {
		  this.search_id = '';
		  this.type = "";
		  this.experiencefindUpdate.next('');
	  }
	  let requestbody={'location_slug':this.slug,'search':val,'location_type':'location-region'};
	  this.addexperience.autocomplete_search(requestbody).subscribe(res=>{
		  if(res.response == 'success')
		  {
			  this.data=res.data;
		  }
	  })
	} */

	select_location(slug) {
		this.search_id = '';
		this.type = "";
		this.page = 1;
		this.current_page = 0;
		this.result = [];
		this.router.navigate(['/location-region/' + slug]);
		this.getAllExperienceData();
	}
	sorting_by(orderby, order) {
		this.search_id = '';
		this.type = "";
		this.page = 1;
		this.result = [];
		this.current_page = 0;
		this.order_by = orderby;
		this.order = order;
		this.getAllExperienceData();
	}
	/* FUNCTION TO SHOW EXPERIENCE DETAILS POPUP */
	showExpDetails(id) {
		this.isLoading = true;
		var requestbody = { 'experience_id': id };
		this.addexperience.getExperienceDetails(requestbody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.experienceDetails = res.data;
				this.data_for_dropdown_in_popup = res.data;
				this.experienceDetails.pricing_option = 1;
				this.data_for_dropdown_in_popup.pricing_option = 1;
				//this.experienceDetailsPopup.show();
				this.ExpDetailService.sendMessage(this.experienceDetails);
			} else if (res.response == 'error') {
				// this.toastr.errorToastr(res.message, 'Error!'); 
			}
			this.isLoading = false;
		});
	}


	add_gift_certificate() {
		this.messageService.sendGiftCertificate(this.certificate_data)
	}

	add_gift_event(e) {
		e.is_buy_for_yourself = 1;
		this.messageService.sendGiftCertificate(e);
	}
	// onSchedulingDateSelect($event) {
	// 	this.result = [];
	// 	this.selected_date = '';

	// 	this.page	=	1;
	// 	this.current_page	=	1;
	// 	this.last_page	=	1;
	// 	var counter = 0;
	// 	var year = "" + $event.getFullYear();
	// 	var month = "" + ($event.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
	// 	var day = "" + $event.getDate(); if (day.length == 1) { day = "0" + day; }
	// 	this.selected_date = year + "-" + month + "-" + day 
	// 	this.getAllExperienceData();
	// }


	onSchedulingDateSelect(event: any) {
		if (event && event.length === 2) {
			const startDate = event[0];
			const endDate = event[1];
			const dateClasses: DatepickerDateCustomClasses[] = [];

			let currentDate = new Date(startDate);
			while (currentDate <= endDate) {
				dateClasses.push({
					date: new Date(currentDate),
					classes: ['date-range-selected']
				});
				currentDate.setDate(currentDate.getDate() + 1);
			}

			this.dateCustomClasses = dateClasses;

			// Check if the dates have changed
			if (!this.isInitialLoad) {
				if (this.previousDateRange) {
					this.isDateChanged = !(
						this.previousDateRange[0].getTime() === startDate.getTime() &&
						this.previousDateRange[1].getTime() === endDate.getTime()
					);
				} else {
					this.isDateChanged = true;
				}
			} else {
				// During the initial load, set isDateChanged to false
				this.isDateChanged = false;
				this.isInitialLoad = false;  // Mark the initial load as complete
			}

			// If initial dates were null and user selects a date range, set isDateChanged to true
			if (this.start_date === undefined || this.start_date === null || this.start_date === '' ||
				this.end_date === undefined || this.end_date === null || this.end_date === '') {
				this.isDateChanged = true;
			}


			// Update the previous date range
			this.previousDateRange = [startDate, endDate];
		}
	}

	onSchedulingDateSelectMobile(event: any) {
		if (event && event.length === 2) {
			const startDate = event[0];
			const endDate = event[1];
			const dateClasses: DatepickerDateCustomClasses[] = [];

			let currentDate = new Date(startDate);
			while (currentDate <= endDate) {
				dateClasses.push({
					date: new Date(currentDate),
					classes: ['date-range-selected']
				});
				currentDate.setDate(currentDate.getDate() + 1);
			}

			this.dateCustomClasses = dateClasses;

			// Check if the dates have changed
			if (!this.isInitialLoad) {
				if (this.previousDateRange) {
					this.isDateChanged = !(
						this.previousDateRange[0].getTime() === startDate.getTime() &&
						this.previousDateRange[1].getTime() === endDate.getTime()
					);
				} else {
					this.isDateChanged = true;
				}
			} else {
				// During the initial load, set isDateChanged to false
				this.isDateChanged = false;
				this.isInitialLoad = false;  // Mark the initial load as complete
			}

			// If initial dates were null and user selects a date range, set isDateChanged to true
			if (this.start_date === undefined || this.start_date === null || this.start_date === '' ||
				this.end_date === undefined || this.end_date === null || this.end_date === '') {
				this.isDateChanged = true;
			}


			// Update the previous date range
			this.previousDateRange = [startDate, endDate];
		}
	}

	chooseMethodTocall(event: any) {
		if (this.isMobile === true) {
			this.onSchedulingDateSelectMobile(event);
		} else {
			this.onSchedulingDateSelect(event);
		}
	}


	onShowPicker(event) {
		if (this.isBrowser) {

			const dayHoverHandler = event.dayHoverHandler;
			const hoverWrapper = (hoverEvent) => {
				const { cell, isHovered } = hoverEvent;
				if ((isHovered &&
					!!navigator.platform &&
					/iPad|iPhone|iPod/.test(navigator.platform)) &&
					'ontouchstart' in window
				) {
					(this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
				}

				return dayHoverHandler(hoverEvent);
			};
			event.dayHoverHandler = hoverWrapper;
		}
	}

	exp_detail(event: Event, slug, exp_pos, request_type = '', record) {
		event.preventDefault();
		this.isRendering = true;
		this.isDataLoading = false;
		//var page_no = this.page;
		var page_no = (this.page == this.last_page) ? this.page + 1 : this.page;

		let gtag_items = [{
			item_id: record?.id,
			item_name: record?.title,
			discount: 0,
			item_brand: record?.company_name,
			item_category: globalConstant?.gtag_item_category,
			item_list_id: this.slug + "_experiences",
			item_list_name: this.slug + "-experiences",
			price: record?.regular_price,
			quantity: globalConstant?.gtag_quantity

		}]

		let gtagData = {
			currency: "USD",
			value: record?.regular_price * globalConstant?.gtag_quantity,
			items: gtag_items
		}

		if(this.baseUrl && (this.baseUrl == 'spurexperiences.com' || this.baseUrl == 'spurexperiences.com/' 
		|| this.baseUrl == 'https://spurexperiences.com/' || this.baseUrl == 'https://spurexperiences.com')) {
		this.analyticsService.analyticsData('select_item', gtagData)
	    }

		/* this._location.replaceState('/location-region/' + this.slug + "?date=" + this.selected_date + "&page=" + (page_no-1) + "&exp_pos=" + exp_pos); */
		this.router.navigate(['/location-region/' + this.slug], {
			queryParams: {
				'start_date': this.start_date,
				'end_date': this.end_date, 'page': (page_no - 1), 'exp_pos': exp_pos, 'is_booking': this.is_booking
			}
		})
		setTimeout(() => {
			this.router.navigate(['/experiences/' + slug], {
				queryParams: {
					'start_date': this.start_date,
					'end_date': this.end_date, 'page': (page_no - 1), 'request_type': request_type
				}
			})
		}, 10)
	}



	getCountryList() {
		this.locationService.getCountryList().subscribe(res => {
			if (res.response == 'success') {
				if (res?.data?.length > 0) {
					//this.slug;	

					for (let i = 0; i < res.data.length; i++) {
						if (res.data[i].image !== "" && res.data[i].image !== undefined && res.data[i].image !== null) {
							res.data[i].image = res.image_url + res.data[i].image;
						}
					}
					this.country_list = res.data;

					// this.country_list.unshift({'id':0, 'text':'All countries'});

					this.country_avail = this.country_list[0] ? this.country_list[0].id : '';

					this.selectedCountry = this.country_list[5];
					this.country_id = 449;
				}
				else {
					this.country_list = [];
					this.country_avail = '';
				}
			}
		});
	}

	getStateList(id = 0) {
		this.locationService.getStateList(id).subscribe(res => {
			if (res.response == 'success') {
				this.state_List = res.data;
				this.state_avail = this.state_List[0] ? this.state_List[0].id : '';
			} else {
				this.state_List = [];
				this.state_avail = '';
			}
		});
	}
	getCityList(id) {
		this.locationService.getCityList(id, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.city_List = res.data;
				this.city_avail = this.city_List[0] ? this.city_List[0].id : '';
			} else {
				this.city_List = [];
				this.city_avail = '';

			}
		});
	}

	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template, { class: 'modal-md modal-dialog-scrollable modal_height  modal-dialog-centered' });
	}

	openStateModal(template: TemplateRef<any>) {
		this.stateModalRef = this.modalService.show(template, { class: 'modal-md modal-dialog-scrollable modal_height  modal-dialog-centered' });
	}


	// get displayedStates() {
	// 	return this.state_List.slice(0, this.initialDisplayCount);
	// }

	// selected_state(id: number) {
	// 	const state = this.state_List.find(state => state.id === id);
	// 	if (state) {
	// 		this.stateModalRef?.hide();
	// 		this.router.navigate([state.slug], { relativeTo: this.activatedRoute });
	// 	}
	// }


	// get displayedContent() {
	// 	return this.locationContent.slice(0, this.initialDisplayCount);
	// }

	loadMore() {
		const nextSet = this.locationContent.slice(this.displayedContent.length, this.displayedContent.length + this.loadCount);
		this.displayedContent = [...this.displayedContent, ...nextSet];
	}

	selected_content(event: Event, slug: number) {
		event.preventDefault();
		if (this.displayState) {
			this.router.navigate(['location-region/' + slug])
		} else {
			this.router.navigate(['location-region/' + this.slug + '/' + slug])
		}
		this.modalRef?.hide();
	}

	select_country(id) {

		if (this.slug == 'travel' || this.check_current_route == 'country-location') {
			for (let i = 0; i < this.country_list.length; i++) {
				if (this.country_list[i].id == id) {
					//this.slug 	=	this.country_list[i].slug;
					this.router.navigate(['/country-location/' + this.country_list[i].slug]);
					break;
				}
			}
		} else {
			for (let i = 0; i < this.country_list.length; i++) {
				if (this.country_list[i].id == id) {
					this.slug = this.country_list[i].slug;
					this.router.navigate(['/location-region/' + this.country_list[i].slug]);
					break;
				}
			}
			this.getStateList(id);
			if (id == this.selected_country_id_at_first) {
				this.getCityList(this.selected_state_id)
			} else {
				this.city_List = [];
			}
			//this.getAllExperienceData();
		}

	}

	select_state(id) {
		this.selected_state_id = id
		for (let i = 0; i < this.state_List.length; i++) {
			if (this.state_List[i].id == id) {
				this.slug = this.state_List[i].slug;
				this.router.navigate(['/location-region/' + this.slug]);
				//this.router.navigate(['/location-region/'+this.slug], { queryParams: { price: JSON.stringify(this.price_filter_options)  }} )
				break;
			}
		}
	}
	select_city(id) {
		this.page = 1;
		this.current_page = 1;
		this.last_page = 1;
		for (let i = 0; i < this.city_List.length; i++) {
			if (this.city_List[i].id == id) {
				this.city_id = this.city_List[i].id;
				this.slug = this.city_List[i].slug;
				this.getAllExperienceData();
			}
		}
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		if (this.subscription != undefined && this.subscription != null) {
			this.subscription.unsubscribe();
		}
		if (this.observer) {
			this.observer.disconnect();
		}
	}

	autocompleteSearch(event) {
		let query = event?.query?.trim();
		let requestbody = { 'location_slug': this.slug, 'search': query, 'location_type': 'location-region' };
		this.addexperience.autocomplete_search(requestbody).subscribe(res => {
			if (res.response == 'success') {
				this.autocompleteExpResults = res.data;
			}
		});
	}

	autocompleteSearchData(event?) {
		let query = event?.query?.trim();
		if (this.enteredValue && this.enteredValue !== '') {
			query = this.enteredValue;
		}
		let requestbody = { 'search': query };
		this.experience.searchExperienceAutocomplete(requestbody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.autocompleteExpResults = res?.data;
				if (this.autocompleteExpResults !== undefined && this.autocompleteExpResults !== null && this.autocompleteExpResults?.length !== 0) {
					this.showRecentSearches = false;
				}
				this.exp_image_url = res.exp_image_url;
				this.location_image_url = res.location_image_url;
				this.category_image_url = res.category_image_url;
			}
		});
	}

	onFocusSearchBox(event?) {
		if (event && event?.type === "focus") {
		  if(this.enteredValue && this.enteredValue !== '') {
			this.showRecentSearches = false;       
			this.autocompleteSearchData();   
			setTimeout(() => {
			  this.autoComplete.show();
			}, 0);   
		  } else {
			this.showRecentSearches = true;
		  }
		}
	  }
	
	  searchedInput(event) {
		let searchedValue = event?.target?.value?.trim();
		if(searchedValue && searchedValue !== '') {
		  this.enteredValue = searchedValue;
		} else {
		  this.enteredValue = '';
		}
	  }

	onSelectAutocompleteSearch(event, isMobile?: boolean) {
		this.autocomplete_search_to = event;
		this.exp_slug = event?.value;
		if (event?.type == 'exp') {
			if (this.exp_slug) {
				if (isMobile) {
					this.router.navigateByUrl('/experiences/' + this.exp_slug).then(() => {
						if (this.isBrowser) {

							window.location.reload();
						}
					});
				} else {
					this.router.navigate(['/experiences/' + this.exp_slug]);
				}
			}
		} else {
			this.isOpenDatePicker = true
		}
	}	

	onBlurSearchBox(event) {
		if (event && event.target && event.target.value) {
			this.isValueSelectedOrEntered = true;
			this.autocomplete_search = event?.target?.value;
		}
		setTimeout(() => {
			this.showRecentSearches = false;
		}, 200);
	}

	selectRecentSearch(searchText: any, isMobile?: boolean) {
		this.selectedNearby = false;
		this.autocomplete_search_to = searchText
		this.autocomplete_search_to['label'] = searchText?.title
		if (searchText?.type == 'exp') {
			if (searchText?.params) {
				if (isMobile) {
					this.router.navigate(['/experiences/' + searchText?.params]).then(() => {
						if (this.isBrowser) {

							window.location.reload();
						}
					});
				} else {
					this.router.navigate(['/experiences/' + searchText?.params]);
				}
			}
		} else {
			this.isOpenDatePicker = true
		}
		if (this.isBrowser) {

			let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue')
			idElement.querySelector('input').value = searchText?.title
		}
		// this.showRecentSearches = false;
	}

	search_clear() {
		if (this.search_id != '') {
			this.search_id = '';
			this.type = '';
			this.search_type = '';
			this.autocompleteExpResults = [];
			this.last_page = 0;
			this.page = 1;
			this.current_page = 0;
			this.result = [];
			this.getAllExperienceData();
		}
	}

	clear_searched_data() {
		this.autocompleteExpResults = [];
	}

	onSelectAutocompleteExperience(event) {
		this.search_id = event.id;
		this.type = event.type;
		this.last_page = 0;
		this.page = 1;
		this.current_page = 0;
		this.category_id = 0;
		this.amount_value = '';
		this.category_name = '';
		this.result = [];
		this.price_filter_search = {};
		this.noRecordFound = false;
		this.getAllExperienceData();
	}


	onSelectAutocompleteLocation(event, isMobile?: boolean) {

		if (this.isBrowser) {

			localStorage.setItem('searchHistory', JSON.stringify(this.searchHistorySave));
		}
		if (this.selectedDateRange.length) {
			this.start_date = this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : ''
			this.end_date = this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
		}
		this.exp_slug = event?.value;

		if (event === undefined && this.slug !== '' && this.isValueSelectedOrEntered === false) {
			let param = {
				is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
				latitude: this.latitude,
				longitude: this.longitude,
				start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
				end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
			}
			this.router.navigate(['/location-region/' + this.slug], { queryParams: param });

		} else if (!event?.label && this.autocomplete_search && this.isValueSelectedOrEntered === true) {
			if (this.isDateChanged === true) {
				let param = {
					title: this.autocomplete_search,
					is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
					start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
					end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
				}
				this.router.navigate(['/experience-name-search'], { queryParams: param })
			} else {
				let param = {
					title: this.autocomplete_search,
					is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
					start_date: this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd'),
					end_date: this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd')
				}
				this.router.navigate(['/experience-name-search'], { queryParams: param })
			}
		} else if (!event?.label && this.autocomplete_search && this.isValueSelectedOrEntered === false) {
			if (this.isDateChanged === true) {
				let param = {
					title: this.autocomplete_search,
					is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
					start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
					end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
				}
				this.router.navigate(['/experience-name-search'], { queryParams: param })
			} else {
				let param = {
					title: this.autocomplete_search,
					is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
					start_date: this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd'),
					end_date: this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd')
				}
				this.router.navigate(['/experience-name-search'], { queryParams: param })
			}

		}
		// Check the selected date range length
		if (this.selectedDateRange?.length > 0) {
			// If the current tab is 0, move to tab 1
			if (this.is_booking === 0) {
				this.is_booking = 1;
			}
			// If the current tab is 1 or 2, do nothing (it remains on the current tab)
		} else {
			// If the selected date range length is 0 or less, set to tab 0
			this.is_booking = 0;
		}


		// if (event && event.type !== undefined && event.type !== null) {
		switch (event?.type) {
			case "exp":
				if (this.exp_slug) {
					this.router.navigate(['/experiences/' + this.exp_slug]);
				}
				break;
			case "location-list":
			case "location":
				let param = {
					is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
					start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
					end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
				}
				if (event.country_slug == null) {
					if (this.isDateChanged === true) {
						let params = {
							is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
							start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
							end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
						}
						this.router.navigate(['/location-region/' + (this.exp_slug ? this.exp_slug : event?.params)], { queryParams: params });
					} else {
						this.router.navigate(['/location-region/' + (this.exp_slug ? this.exp_slug : event?.params)], { queryParams: param });
					}

				} else if (event.country_slug != null && event.state_slug != null) {
					if (this.isDateChanged == true) {
						let params = {
							is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
							latitude: this.latitude,
							longitude: this.longitude,
							start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
							end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
						}
						this.router.navigate(['/location-region/' + event.state_slug + '/' + (this.exp_slug ? this.exp_slug : event?.params)], { queryParams: params });
					} else {
						this.router.navigate(['/location-region/' + event.state_slug + '/' + (this.exp_slug ? this.exp_slug : event?.params)], { queryParams: param });

					}
				}
				break;
			case "higher-level-category":
			case "category":
				if (this.isValueSelectedOrEntered == false) {
					if (this.isDateChanged == false) {
						if (event?.id && event?.id !== '') {
							this.router.navigate(['/experience/' + (this.exp_slug ? this.exp_slug : event?.params)]);
						} else {
							this.router.navigate(['/experience-name-search'], {
								queryParams: {
									title: event.label,
									search_id: event.id,
									type: event.type,
									is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
									start_date: this.selectedDateRange[0],
									end_date: this.selectedDateRange[1]
								}
							});
						}
						
					} else {
						if (event?.id && event?.id !== '') {
							this.router.navigate(['/experience/' + (this.exp_slug ? this.exp_slug : event?.params)]);
						} else {
						this.router.navigate(['/experience-name-search'], {
							queryParams: {
								title: event.label,
								search_id: event.id,
								type: event.type,
								is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
								start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
								end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
							}
						 });
					    }
					}
				} else if (this.isValueSelectedOrEntered === true) {
					if (this.isDateChanged === false) {
						if (event?.id && event?.id !== '') {
							this.router.navigate(['/experience/' + (this.exp_slug ? this.exp_slug : event?.params)]);
						} else {
						this.router.navigate(['/experience-name-search'], {
							queryParams: {
								title: event.label,
								search_id: event.id,
								type: event.type,
								is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
								start_date: this.selectedDateRange[0],
								end_date: this.selectedDateRange[1]
							}
						 });
				    	}
					} else {
						if (event?.id && event?.id !== '') {
							this.router.navigate(['/experience/' + (this.exp_slug ? this.exp_slug : event?.params)]);
						} else {
						this.router.navigate(['/experience-name-search'], {
							queryParams: {
								title: event.label,
								search_id: event.id,
								type: event.type,
								is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
								start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
								end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
							}
						});
					   }
					}

				}
			 break;
			case undefined:
				if (this.isBrowser) {

					let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue')

					if (this.selectedNearby === true && this.slug !== undefined && this.slug !== null && this.slug !== '' && idElement.querySelector('input').value === '') {
						if (this.isDateChanged === true) {
							let param = {
								is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
								latitude: this.latitude,
								longitude: this.longitude,
								start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
								end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
							}
							this.router.navigate(['/location-region/' + this.slug], { queryParams: param });
						} else {
							let param = {
								is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
								latitude: this.latitude,
								longitude: this.longitude,
								start_date: this.selectedDateRange[0],
								end_date: this.selectedDateRange[1]
							}
							this.router.navigate(['/location-region/' + this.slug], { queryParams: param });
						}

					} else if (this.selectedNearby === true && event && this.city !== undefined && this.city !== null) {
						if (this.isDateChanged === true) {
							this.router.navigate(['/location-region/' + this.city], {
								queryParams: {
									is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
									latitude: this.latitude,
									longitude: this.longitude,
									start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
									end_date: this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
								}
							});
						} else {
							this.router.navigate(['/location-region/' + this.city], {
								queryParams: {
									is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
									latitude: this.latitude,
									longitude: this.longitude,
									start_date: this.selectedDateRange[0],
									end_date: this.selectedDateRange[1]
								}
							});
						}

					} else {
						if (this.selectedNearby === true && ((idElement.querySelector('input').value !== undefined && idElement.querySelector('input').value !== null) ||
							(event?.label !== undefined && event?.label !== null))) {
							this.router.navigate(['/experience-name-search'], {
								queryParams: {
									title: idElement.querySelector('input').value ? idElement.querySelector('input').value : event?.label,
									start_date: this.selectedDateRange[0],
									end_date: this.selectedDateRange[1]
								}
							});
						}
					}
				}
				break;
		}
		// }
	}

	onChangeSearch(event: any) {
		if (event && event?.value) {
			this.searchedItem = event?.value;
		} else {
			this.searchedItem = '';
		}
		if (event.itemData) {
			this.search_id = event.itemData.id;
			this.type = event.itemData.type;
		} else {
			this.search_id = '';
			this.type = '';
		}
		this.page = 1;
		this.amount_value = '';
		this.category_name = '';
		this.result = [];
		this.last_page = 0;
		this.current_page = 0;
		this.category_id = 0;
		this.order_by = '';
		this.order = '';
		this.noRecordFound = false;
		this.isLoading = false;
		const startDateParam = this.start_date !== undefined && this.start_date !== null ? this.start_date : '';
		const endDateParam = this.end_date !== undefined && this.end_date !== null ? this.end_date : '';

		this._location.replaceState('/location-region/' + this.slug +
			"?page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking +
			(this.is_booking > 0 ? ("&start_date=" + startDateParam + "&end_date=" + endDateParam) : ''));
		this.getAllExperienceData();
	}

	/* onFiltering(e: FilteringEventArgs){
		this.save_filter_event=e;
	} */

	onFiltering_after_debounce(e?) {
		let searchKeyword = e.text.trim();
		let requestbody = { 'location_slug': this.slug, 'search': searchKeyword, 'location_type': 'location-region', 'at_home': this.at_home };
		this.addexperience.autocomplete_search(requestbody).subscribe(res => {
			if (res.response == 'success') {
				setTimeout(function () {
					this.autocompleteData = res.data;
					e.updateData(this.autocompleteData);
				}, 10);
			}
		});
	}

	owlExpDetail: OwlOptions = {
		loop: false,
		mouseDrag: false,
		autoplay: false,
		touchDrag: true,
		pullDrag: false,
		dots: false,
		autoWidth: true,
		navSpeed: 700,
		nav: true,
		navText: ["<i class='fas fa-chevron-left cusLeft'></i>", "<i class='fas fa-chevron-right cusRight'></i>"],
		items: 1,
		rewind: false,
		margin: 0,

	}

	at_home_exp(input) {
		this.at_home = input.target.checked;
		this.currentIW = '';
		this.previousIW = '';
		this.page = 1;
		this.current_page = 1;
		this.last_page = 1;
		this.result = [];
		this.getAllExperienceData();
	}

	getExpQuantity(data) {
		if (data?.length > 0) {
			data.forEach((element, i) => {
				let seats = this.max_quantity_count;
				let book_denominator = element.book_denominator;
				let individual_price = element.for_individual_price;
				let people_options = [];
				if (Number(seats) > 0) {
					for (let i = 1; i <= Number(seats); i++) {
						//let personOptions = {};
						if (i == 1) {
							var personName = 'Person';
						} else {
							var personName = 'People';
						}
						// book_denominator = 2 
						if (Number(book_denominator) > 1) {
							if ((Number(i) % Number(book_denominator)) === 0) {
								let pQty = Number(i) / Number(book_denominator);
								people_options.push({ 'key': i, 'value': i + ' ' + personName });
							}

						} else if (Number(individual_price) == 0) {
							if ((Number(i) % 2) === 0) {
								let pQty = Number(i) / 2;
								people_options.push({ 'key': i, 'value': i + ' ' + personName });
							}
						} else {
							people_options.push({ 'key': i, 'value': i + ' ' + personName });
						}
						if (i == 10) {
							break;
						}
					}
				}
				element['book_quantity_options'] = people_options;
				if (element?.price_label_dropdown?.length > 0) {
					element['book_quantity_options'] = element?.price_label_dropdown

				}
			});
		}
		// Check If Booking People selection quantity is allowed on experience end or not.

	}

	addCartQuantity(i, record, id) {
		var cartitems: any = [];
		if (this.isBrowser) {

			if (localStorage.getItem('cart_details')) {
				cartitems = JSON.parse(localStorage.getItem('cart_details'));
			}
		}
		let hasPresentOn = cartitems.find(
			function (el) {
				if (el.product_id === record?.id) {
					return true;
				} else {
					return false;
				}
			}
		);
		if (!hasPresentOn) {
			for (let i = 0; i < this.result.length; i++) {
				if (this.isBrowser) {
					let element = document.getElementById(id + i);
					if (element) {
						element.classList.remove("active");
					}
				}
			}
			if (this.isBrowser) {
				let element = document.getElementById(id + i);
				if (element) {  // Add null check here
					element.classList.add("active");
				}
			}
		}
		else {

			this.toastr.errorToastr("Already added in your cart.", 'Error!');
		}


	}
	removeClass(i, id) {
		if (this.isBrowser) {

			let element = document.getElementById(id + i)
			if (element) {
				element.classList.remove("active");
			}
		}
	}


	clearRecentSearch() {
		this.searchHistory = []
		if (this.isBrowser) {

			if (localStorage.getItem('searchHistory')) {
				localStorage.removeItem('searchHistory')
			}
		}
	}
	clearDate() {
		this.selectedDateRange = [];
	}


	onFiltering(event: any) {
		this.modelChanged2.next(event?.query);
		this.Query = event.query;
	}
	onFilteringAfterDebounce(query: string) {
		const searchKeyword = query.trim();
		const requestbody = {
			search: searchKeyword,
			location_travel: this.location_travel,
			location: this.location,
			city: this.city,
			at_home: this.at_home,
			location_slug: this.slug,
		};
		this.addexperience.autocomplete_search(requestbody).subscribe(res => {
			if (res.response === 'success') {
				setTimeout(() => {
					this.autocompleteData = res.data;
					this.groupItemsDynamically();
				}, 10);
			}
		});
	}

	onChangeSearch1(event: any) {
		if (event && event?.query) {
			this.searchedItem = event?.query;
			this.onFiltering_after_debounce()
		} else {
			this.searchedItem = '';
		}
		if (event?.value) {
			this.search_id = event?.value?.id;
			this.type = event?.value?.type;
			this.searchedItem = "";
		} else {
			this.search_id = '';
			this.type = '';
		}
		this.page = 1;
		this.amount_value = '';
		this.category_name = '';
		this.result = [];
		this.last_page = 0;
		this.current_page = 0;
		this.category_id = 0;
		this.order_by = '';
		this.order = '';
		this.noRecordFound = false;
		this.isLoading = false;
		const startDateParam = this.start_date !== undefined && this.start_date !== null ? this.start_date : '';
		const endDateParam = this.end_date !== undefined && this.end_date !== null ? this.end_date : '';

		this._location.replaceState('/location-region/' + this.slug +
			"?page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking +
			(this.is_booking > 0 ? ("&start_date=" + startDateParam + "&end_date=" + endDateParam) : ''));
		this.getAllExperienceData();
	}

	groupItemsDynamically() {
		const groups: { [key: string]: any } = {};
		if (this.autocompleteData.length > 0) {

			this.autocompleteData.forEach(item => {
				const groupKey = item.type;
				if (!groups[groupKey]) {
					groups[groupKey] = {
						label: `By ${item.type === 'category' ? 'Category' : 'Name'}`,
						type: item.type,
						items: []
					}
				}
				groups[groupKey].items.push({ id: item.id, value: item.value, label: item.label, type: item.type });
			});
		}
		this.groupedData = Object.values(groups);
		this.filterGroupedCity()
	}

	filterGroupedCity() {
		let query = this.Query
		let filteredGroups = [];

		for (let optgroup of this.groupedData) {
			let filteredSubOptions = this.filterService.filter(optgroup.items, ['label'], query, "contains");
			if (filteredSubOptions && filteredSubOptions.length) {
				filteredGroups.push({
					label: optgroup.label,
					value: optgroup.value,
					items: filteredSubOptions
				});
			}
		}

		this.filteredGroups = filteredGroups;
	}


	onEnter(event) {
		if (event.key === "Enter") {
			this.onFilteringAfterDebounce(this.Query)
			this.searchedItem = this.Query;
			this.search_id = '';
			this.type = '';
			this.page = 1;
			this.amount_value = '';
			this.category_name = '';
			this.result = [];
			this.last_page = 0;
			this.current_page = 0;
			this.category_id = 0;
			this.order_by = '';
			this.order = '';
			this.noRecordFound = false;
			this.isLoading = false;
			const startDateParam = this.start_date !== undefined && this.start_date !== null ? this.start_date : '';
			const endDateParam = this.end_date !== undefined && this.end_date !== null ? this.end_date : '';

			this._location.replaceState('/location-region/' + this.slug +
				"?page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking +
				(this.is_booking > 0 ? ("&start_date=" + startDateParam + "&end_date=" + endDateParam) : ''));
			this.getAllExperienceData();

		}
	}

	addMetaTags() {
		this.metaService.updateTag({ property: 'og:url', content: this.pageUrl });
		this.metaService.updateTag({ property: 'og:image', content: this.main_image_url + this.resultContent.image });
		if (this.resultContent && this.resultContent?.seo_title != '') {
			this.metaService.updateTag({ property: 'og:title', content: this.resultContent?.seo_title });
			this.titleService.setTitle(this.resultContent?.seo_title);
		} else {
			this.metaService.updateTag({ property: 'og:title', content: this.resultContent?.name });
			this.titleService.setTitle(this.resultContent?.name);
		}
		if (this.resultContent && this.resultContent?.seo_description != '') {
			this.metaService.updateTag({ property: 'og:description', content: this.resultContent?.seo_description });
			this.metaService.updateTag({ property: 'description', content: this.resultContent?.seo_description });
		} else {
			this.metaService.updateTag({ property: 'og:description', content: this.resultContent?.name });
			this.metaService.updateTag({ property: 'description', content: this.resultContent?.name });
		}
	}

	changeView() {
		this.gridView = !this.gridView;
	}

}
